/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class MenuGridConfiguration extends DaoModel {
  constructor(guid, column, row, gridTemplateAreas, padding, backgroundImage,
    aspectRatio, backgroundImageSizeBehaviour) {
    super(guid);
    this.column = column;
    this.row = row;
    this.gridTemplateArea = gridTemplateAreas;
    this.padding = padding;
    this.backgroundImage = backgroundImage || null;
    this.aspectRatio = aspectRatio;
    this.backgroundImageSizeBehaviour = backgroundImageSizeBehaviour;
  }

  static toInstance(props = {}) {
    return new MenuGridConfiguration(props.guid, props.column, props.row, props.grid_template_areas,
      props.padding, props.background_image, props.aspect_ratio, props.background_image_size_behaviour);
  }

  serialize() {
    return {
      ...super.serialize(),
      column: this.column,
      row: this.row,
      padding: this.padding,
      background_image: this.backgroundImage,
      grid_template_areas: this.gridTemplateArea,
      aspect_ratio: this.aspectRatio,
      background_image_size_behaviour: this.backgroundImageSizeBehaviour,
    };
  }

  getFormData() {
    const formData = new FormData();
    formData.append('column', this.column);
    formData.append('row', this.row);
    formData.append('padding', this.padding);
    formData.append('grid_template_areas', this.gridTemplateArea);
    formData.append('aspect_ratio', this.aspectRatio);
    formData.append('background_image_size_behaviour', this.backgroundImageSizeBehaviour);
    if (this.backgroundImage instanceof File) {
      if (this.backgroundImage.size !== 0) {
        formData.append('background_image', this.backgroundImage, this.backgroundImage.name);
      }
    } else if (!this.backgroundImage) {
      formData.append('background_image', '');
    }

    return formData;
  }
}
